var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyfintoodark2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4657 1.5C8.4657 0.670312 9.13601 0 9.9657 0H11.4657C12.2954 0 12.9657 0.670312 12.9657 1.5C13.7954 1.5 14.4657 2.17031 14.4657 3V13.5C14.4657 14.3297 13.7954 15 12.9657 15C12.9657 15.8297 12.2954 16.5 11.4657 16.5H9.9657C9.13601 16.5 8.4657 15.8297 8.4657 15C7.63601 15 6.9657 14.3297 6.9657 13.5V3C6.9657 2.17031 7.63601 1.5 8.4657 1.5ZM2.4657 21H15.9657C19.2798 21 21.9657 18.3141 21.9657 15C21.9657 11.6859 19.2798 9 15.9657 9V6C20.9344 6 24.9657 10.0312 24.9657 15C24.9657 17.3062 24.0985 19.4062 22.6735 21H23.4657C24.2954 21 24.9657 21.6703 24.9657 22.5C24.9657 23.3297 24.2954 24 23.4657 24H15.9657H2.4657C1.63601 24 0.965698 23.3297 0.965698 22.5C0.965698 21.6703 1.63601 21 2.4657 21ZM6.2157 18H15.2157C15.6282 18 15.9657 18.3375 15.9657 18.75C15.9657 19.1625 15.6282 19.5 15.2157 19.5H6.2157C5.8032 19.5 5.4657 19.1625 5.4657 18.75C5.4657 18.3375 5.8032 18 6.2157 18Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyfintoodark2);
export default __webpack_public_path__ + "static/media/whyfintoodark2.6f43904d5aa2c41e959c03d406222729.svg";
export { ForwardRef as ReactComponent };